<template>
  <div class="app-content--equal-padding py-12 py-md-8 px-7 px-md-16">
    <header class="mb-8">
      <v-card-title
        class="headline font-weight-bold mb-1 pa-0 letter-spacing-compact"
      >
        1. Select Project
      </v-card-title>
    </header>
    <v-row class="mt-0" v-if="request.project_id">
      <v-col class="py-0 mb-5">
        <div class="d-flex justify-space-between align-center">
          <div class="d-flex align-center mb-4">
            <v-avatar class="border-radius-1" size="65px">
              <v-img
                :src="getMedia(request.project)"
                lazy-src="/placeholder.jpg"
                aspect-ratio="1"
                class="grey lighten-2"
              />
            </v-avatar>
            <v-list-item color="primary" class="ml-4">
              <v-list-item-content>
                <v-list-item-title
                  class="title font-weight-bold letter-spacing-compact"
                >
                  {{ request.project.name }}
                </v-list-item-title>
                <span class="caption">
                  {{ request.project.manager.full_name }}
                </span>
              </v-list-item-content>
            </v-list-item>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="!hasProject">
      <v-col class="py-3 mb-5">
        <div id="projectSearch" class="position-relative notranslate">
          <ValidationProvider
            name="project"
            rules="required"
            v-slot="{ errors }"
          >
            <v-autocomplete
              :search-input.sync="projectFilter"
              @input="selectProject"
              :items="projects"
              :multiple="false"
              attach="#projectSearch"
              item-text="name"
              return-object
              label="Search Project"
              append-icon="$search"
              :error="Boolean(errors.length)"
              class="font-weight-bold"
              color="black"
            />
            <input type="hidden" v-model="request.project_id" />
            <div
              v-if="errors.length"
              class="v-messages theme--light error--text mt-n4"
              role="alert"
            >
              <div class="v-messages__wrapper">
                <div class="v-messages__message">{{ errors[0] }}</div>
              </div>
            </div>
          </ValidationProvider>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="!hasProject">
      <v-col class="py-3 mb-5">
        <v-btn color="white" large block @click.stop="newProject = !newProject">
          New Project
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog
      fullscreen
      v-model="newProject"
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card class="modal-card">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="newProject = false">
            <v-icon>$close</v-icon>
          </v-btn>
          <v-toolbar-title class="px-12">Add new project</v-toolbar-title>
          <v-spacer />
        </v-toolbar>
        <v-card-text>
          <NewProject
            v-if="newProject"
            customExit="exit"
            @exit="newProjectFinished"
            class="px-md-14"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PayoutRequest from '@request/PayoutRequest';
import Project from '@models/Project';

export default {
  name: 'SelectProject',
  components: {
    NewProject: () => import('@pages/projects/Create'),
  },
  props: {
    request: {
      type: PayoutRequest,
      required: true,
    },
    hasProject: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newProject: false,
      projects: [],
      projectFilter: '',
      projectModel: new Project({
        itemsPerPage: 5,
        relations: ['manager'],
        filters: {
          graduated: false,
        },
      }),
    };
  },
  watch: {
    projectFilter() {
      this.fetchProject();
    },
  },
  methods: {
    async fetchProject() {
      this.projectModel.setFilters({
        name: this.projectFilter,
      });
      let response = await this.projectModel.get();
      if (response) {
        this.projects = response.data;
      }
    },
    selectProject(project) {
      this.request.reinit({
        project,
        project_id: project.id,
        amount: this.request.amount,
        percentage: this.request.percentage,
      });
    },
    newProjectFinished(data) {
      if (data) {
        this.selectProject(data);
      }
      this.newProject = false;
    },
  },
  mounted() {
    this.fetchProject();
  },
};
</script>

<style lang="scss" scoped></style>
